import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { SidebarProvider } from '@/components/ui/sidebar';
import { useEffect, useState } from 'react';
import { SearchProvider, useSearch } from '@/contexts/SearchContext';
import { ElevenLabsWidget } from '@/components/help/ElevenLabsWidget';
import { SymphonyWidget } from '@/symphony/SymphonyWidget';
import { useSymphonyWidgetEnabled } from '@/symphony/useSymphonyWidgetEnabled';
import { SubscriptionBanner } from '@/components/billing/SubscriptionBanner';
// Old chatbot kept for potential rollback:
// import { HelpChatbot } from '@/components/help/HelpChatbot';

const LayoutContent = () => {
  const [defaultOpen, setDefaultOpen] = useState(false);
  const { searchValue, setSearchValue, searchPlaceholder } = useSearch();
  const symphonyEnabled = useSymphonyWidgetEnabled();
  
  console.log('Layout render - defaultOpen:', defaultOpen);
  console.log('Layout render - window width:', typeof window !== 'undefined' ? window.innerWidth : 'SSR');

  useEffect(() => {
    // Set default open state based on screen size
    const checkScreenSize = () => {
      setDefaultOpen(window.innerWidth >= 1024); // lg breakpoint
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <div className="min-h-screen bg-background w-full flex">
        <Sidebar />
        <div className="flex-1 flex flex-col min-h-0">
          <Header 
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            searchPlaceholder={searchPlaceholder}
          />
          <SubscriptionBanner />
          <main className="flex-1 p-6 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
      {symphonyEnabled ? <SymphonyWidget /> : <ElevenLabsWidget />}
      {/* <HelpChatbot /> */}
    </SidebarProvider>
  );
};

export const Layout = () => {
  return (
    <SearchProvider>
      <LayoutContent />
    </SearchProvider>
  );
};